import APIService from '@/services/APIService';

export default {
  list(params) {
    return APIService.get('/exports', { params });
  },
};
